import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <h1>Termos e Condições</h1>
        <div className="terms-last-updated">
          <p>Última atualização: Julho 2025</p>
        </div>

        <section className="terms-section">
          <h2>1. Aceitação dos Termos</h2>
          <p>
            Ao aceder e utilizar o website da MercadoTV, você concorda em cumprir e estar vinculado a estes 
            Termos e Condições de utilização. Se não concordar com qualquer parte destes termos, não deve 
            utilizar o nosso serviço.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Descrição do Serviço</h2>
          <p>
            A MercadoTV é uma plataforma de comércio eletrónico especializada em equipamentos de segurança 
            eletrónica, incluindo sistemas de videovigilância, alarmes e videoporteiros. Oferecemos produtos 
            e serviços de instalação sem mensalidades.
          </p>
        </section>

        <section className="terms-section">
          <h2>3. Conta de Utilizador</h2>
          <p>
            Para efetuar compras, é necessário criar uma conta. Você é responsável por manter a 
            confidencialidade das suas credenciais de acesso e por todas as atividades que ocorram sob a sua conta.
          </p>
          <ul>
            <li>As informações fornecidas devem ser verdadeiras e atualizadas</li>
            <li>Deve notificar-nos imediatamente sobre qualquer uso não autorizado da sua conta</li>
            <li>Reservamo-nos o direito de suspender ou encerrar contas que violem estes termos</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>4. Produtos e Preços</h2>
          <p>
            Todos os produtos estão sujeitos a disponibilidade. Os preços apresentados incluem IVA e podem 
            ser alterados sem aviso prévio. Reservamo-nos o direito de corrigir erros de preços.
          </p>
          <ul>
            <li>Todos os custos são únicos (compra/instalação) sem mensalidades</li>
            <li>As imagens podem não corresponder exatamente ao produto no mercado português</li>
            <li>As especificações técnicas podem variar ligeiramente</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>5. Entrega e Instalação</h2>
          <p>
            Os prazos de entrega são estimativos e podem variar. A instalação é realizada por técnicos 
            especializados em horário a combinar com o cliente.
          </p>
        </section>

        <section className="terms-section">
          <h2>6. Política de Devolução</h2>
          <p>
            A MercadoTV oferece as seguintes condições de devolução para garantir a sua satisfação:
          </p>
          <ul>
            <li><strong>15 dias de devolução:</strong> Pode devolver produtos não instalados no prazo de 15 dias após a entrega</li>
            <li>Os produtos devem estar em estado original, com embalagem e acessórios completos</li>
            <li>Produtos personalizados ou instalados não são elegíveis para devolução, exceto em caso de defeito</li>
            <li>O reembolso será processado no prazo de 10 dias úteis após receção da devolução</li>
            <li>As despesas de envio de devolução ficam a cargo do cliente, exceto em caso de defeito ou erro da nossa parte</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>7. Garantia</h2>
          <p>
            A MercadoTV proporciona uma garantia abrangente para todos os nossos produtos e serviços:
          </p>
          <ul>
            <li><strong>Garantia de 3 anos:</strong> Cobertura completa de material e instalação por 3 anos</li>
            <li>A garantia cobre defeitos de fabrico e problemas relacionados com a instalação</li>
            <li>Assistência técnica gratuita durante o período de garantia</li>
            <li>Substituição de equipamentos defeituosos sem custos adicionais</li>
            <li>A garantia não cobre danos causados por mau uso, fenómenos naturais ou intervenções de terceiros</li>
            <li>Para acionar a garantia, contacte o nosso serviço de apoio ao cliente</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>8. Propriedade Intelectual</h2>
          <p>
            Todo o conteúdo do website, incluindo textos, imagens, logótipos e design, é propriedade da 
            MercadoTV e está protegido por direitos de autor.
          </p>
        </section>

        <section className="terms-section">
          <h2>9. Privacidade</h2>
          <p>
            A recolha e tratamento de dados pessoais é feita de acordo com a nossa Política de Privacidade 
            e em conformidade com o RGPD (Regulamento Geral sobre a Proteção de Dados).
          </p>
        </section>

        <section className="terms-section">
          <h2>10. Limitação de Responsabilidade</h2>
          <p>
            A MercadoTV não se responsabiliza por danos indiretos, incidentais ou consequenciais decorrentes 
            do uso dos nossos produtos ou serviços.
          </p>
        </section>

        <section className="terms-section">
          <h2>11. Alterações aos Termos</h2>
          <p>
            Reservamo-nos o direito de modificar estes termos a qualquer momento. As alterações entrarão 
            em vigor após a publicação no website.
          </p>
        </section>

        <section className="terms-section">
          <h2>12. Lei Aplicável</h2>
          <p>
            Estes termos são regidos pela lei portuguesa. Qualquer litígio será resolvido pelos tribunais 
            competentes de Vale de Cambra, Portugal.
          </p>
        </section>

        <section className="terms-section">
          <h2>13. Contacto</h2>
          <p>
            Para questões relacionadas com estes Termos e Condições, pode contactar-nos através de:
          </p>
          <ul>
            <li>Email: mlptelecomunicacoes@gmail.com</li>
            <li>Telefone: +351 256 418 202</li>
            <li>Morada: Rua do Mercado nº298, Vale de Cambra, Portugal</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;
